const MODULES = {
  INITIATIVES: "Initiatives",
  KEY_RESULTS: "Key results",
  MILESTONE: "Milestone",
  OBJECTIVES: "Objectives",
  ROLE_MANAGEMENT: "Role Management",
  LOGOUT: "Logout",
};

export default MODULES;
